import clsx from 'clsx';
import React from 'react';

import Spinner from '@components/Spinner';

import { DEFAULT_READING_STAT_VALUES } from './constants';

const MyTIReadingStat = ({ index, name, small = false, value }) => {
  return (
    <div
      className={clsx(
        'shrink-0 border-0 border-solid border-grayscale-gray last-of-type:border-r-0 last-of-type:pr-0 sm:w-[calc(50%-64px)] sm:border-r sm:pr-32 md:w-auto lg:pr-64',
        index === 1 && 'sm:border-r-0 sm:pr-0 md:border-r md:pr-32 lg:pr-64'
      )}
    >
      <dl className="m-0 flex h-full flex-col items-center justify-between gap-16 text-center">
        <dt className="order-2 m-0 font-suisse-intl-mono text-overline-lg text-black">{name}</dt>
        <dd
          className={clsx(
            'order-1 m-0 font-suisse-screen font-normal leading-[1.3] text-primary-magenta',
            small ? 'text-[clamp(1.375rem,2.5vw,2.5rem)]' : 'text-headline-alt-md'
          )}
        >
          {DEFAULT_READING_STAT_VALUES.includes(value) ? (
            <span className="text-grayscale-gray">
              <Spinner marginY="small" />
            </span>
          ) : (
            value
          )}
        </dd>
      </dl>
    </div>
  );
};

export default MyTIReadingStat;
